export const ICON_NAMES = {
  search: 'v4_search',
  searchClose: 'close',
  referral: 'referral',
  club: 'club',
  account: 'v4_user',
  cart: 'v4_cart',
  bag: 'v4_bag',
  calculator: 'calculator'
};